export default "__VITE_ASSET__Cqmbd1VE__"